import React from 'react';
import DocumentTitle from 'react-document-title';

const PageNotFound = () => {
  return (
    <DocumentTitle title='Page Not Found'>
      <h1>Page Not Found</h1>
    </DocumentTitle>
  )
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/not-found.js